import React from "react";
import { PlayCircle, Loader2, XCircle, Trash2, CheckCircle2 } from "lucide-react";

const STATUS_META = {
  processing: { icon: Loader2, cls: "text-amber-400 animate-spin", label: "Generating AI notes..." },
  ready: { icon: CheckCircle2, cls: "text-emerald-400", label: "AI notes ready" },
  failed: { icon: XCircle, cls: "text-rose-400", label: "AI notes failed" },
};

export default function VideoManageRow({ video, onDelete }) {
  const meta = STATUS_META[video.transcript_status] || STATUS_META.processing;
  const Icon = meta.icon;
  return (
    <div className="glass-panel rounded-xl p-4 flex items-center justify-between gap-3" data-testid={`video-manage-row-${video.id}`}>
      <div className="flex items-center gap-3 min-w-0">
        <PlayCircle className="w-4 h-4 text-slate-400 shrink-0" />
        <div className="min-w-0">
          <p className="text-sm font-medium text-white truncate">{video.title}</p>
          <p className={`text-xs flex items-center gap-1 mt-0.5 ${meta.cls.replace("animate-spin", "")}`}>
            <Icon className={`w-3 h-3 ${meta.cls.includes("animate-spin") ? "animate-spin" : ""}`} /> {meta.label}
          </p>
          {video.transcript_status === "failed" && video.error_message && (
            <p className="text-[11px] text-rose-400/80 mt-0.5">{video.error_message}</p>
          )}
        </div>
      </div>
      <button onClick={() => onDelete(video.id)} data-testid={`video-manage-delete-btn-${video.id}`} className="text-slate-500 hover:text-rose-400 transition-colors shrink-0">
        <Trash2 className="w-4 h-4" />
      </button>
    </div>
  );
}
